import React, { CSSProperties, FC } from 'react'
import { CircularProgressProps } from './types'
import { InnerCircle, OuterCircle, SVG } from './styles'

export const CircularProgress: FC<{
	circularProgressOptions: CircularProgressProps
	children?: React.ReactNode
	style?: CSSProperties
	onClick?: () => void
}> = ({ circularProgressOptions, children, style, onClick }) => {
	const normalizedRadius: number =
		circularProgressOptions.radius - circularProgressOptions.stroke * 2
	const circumference: number = normalizedRadius * 2 * Math.PI
	const strokeDashoffset: number =
		circumference - (circularProgressOptions.percentage / 100) * circumference

	return (
		<SVG radius={circularProgressOptions.radius} style={style} onClick={onClick}>
			<OuterCircle
				color={circularProgressOptions.backgroundColor}
				stroke={circularProgressOptions.stroke}
				r={normalizedRadius}
				cx={circularProgressOptions.radius}
				cy={circularProgressOptions.radius}
			/>
			<InnerCircle
				color={circularProgressOptions.color}
				stroke={circularProgressOptions.stroke}
				radius={circularProgressOptions.radius}
				strokeDasharray={`${circumference} ${circumference}`}
				style={{ strokeDashoffset }}
				r={normalizedRadius}
				cx={circularProgressOptions.radius}
				cy={circularProgressOptions.radius}
			/>

			{children && (
				<foreignObject
					x={0}
					y={0}
					width={circularProgressOptions.radius * 2}
					height={circularProgressOptions.radius * 2}>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '100%',
							width: '100%',
						}}>
						{children}
					</div>
				</foreignObject>
			)}
		</SVG>
	)
}
